var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 80,
    viewBox: "0 0 60 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8340_67466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 80,
    rx: 4,
    fill: "#E0E0E0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8340_67466)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.2034,
    height: 80,
    fill: "#F1F1F1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4318 55.3981C45.4318 55.1903 45.168 55.1279 45.168 55.1279C42.5304 54.6398 40.0679 52.8039 38.2052 50.8422C35.639 48.0783 33.4244 45.0077 31.612 41.7002C31.3185 41.018 31.7373 40.9454 31.7373 40.9454C36.8773 38.9675 37.7243 33.8344 37.7243 32.43C37.7175 25.9222 31.5593 24 26.0077 24C23.9143 24 23.2122 24.1746 21.0296 24.1746C18.491 24.1746 16.9647 24 16.5727 24C16.4912 24.0037 16.4113 24.024 16.338 24.0596C16.2646 24.0951 16.1993 24.1453 16.146 24.207C16.0926 24.2687 16.0525 24.3407 16.0279 24.4184C16.0033 24.4962 15.9948 24.5781 16.003 24.6593C16.003 26.2285 19.5866 23.5616 19.5866 28.8065V49.7343C19.5857 54.585 16.1768 53.2321 16.1768 54.4121C16.1768 54.8076 16.6117 54.9363 16.8726 54.9363C18.1418 54.9363 19.5823 54.7617 21.6362 54.7617C24.2176 54.7617 24.8701 54.9363 26.3569 54.9363C27.4482 54.9363 27.6228 54.7188 27.6228 54.4121C27.6228 52.9288 23.035 55.2001 23.035 48.9068V26.8419C23.035 25.525 23.9976 25.525 25.3956 25.525C30.4196 25.525 34.3957 28.324 34.4815 33.6084C34.5409 37.1919 31.8439 40.5941 27.4036 40.5941C26.8765 40.617 26.3484 40.5861 25.8276 40.5019C25.6101 40.5019 25.3892 40.5911 25.3892 40.8944C25.3892 41.2933 25.7189 41.501 26.0914 41.6097C27.2687 41.9526 28.2672 42.7384 28.8772 43.8021V43.8021C31.8444 48.6813 35.2066 56 42.8528 56C45.7142 56 45.4241 55.6704 45.4241 55.4002",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyVertical);
export default __webpack_public_path__ + "static/media/empty-vertical.ca33aecfa229886aad3849b6a1b7be4b.svg";
export { ForwardRef as ReactComponent };